import React, { useState } from 'react';
import SettingsProjectsTab from './SettingsProjectsTab';
import SettingsOrganisationTab from './SettingsOrganisationTab';
import SettingsUsersTab from './SettingsUsersTab';
import SettingsApiKeysTab from './SettingsApiKeysTab';
import { Box, Heading, Tabs, TabList, TabPanels, Tab, TabPanel, useColorModeValue } from '@chakra-ui/react';

// function PlaceholderTab({ label }) {
//   return <Box p={8} color="gray.500">{label} management coming soon.</Box>;
// }

const TABS = [
  { key: 'projects', label: 'Projects', component: SettingsProjectsTab },
  { key: 'users', label: 'Users', component: SettingsUsersTab },
  { key: 'apikeys', label: 'API Keys', component: SettingsApiKeysTab },
  { key: 'orgs', label: 'Organisations', component: SettingsOrganisationTab },
];

export default function SettingsPage(props) {
  const [tab, setTab] = useState('projects');
  const activeTabObj = TABS.find(t => t.key === tab);
  const ActiveTab = activeTabObj?.component || (() => null);

  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const tabColor = useColorModeValue('gray.600', 'gray.300');
  const selectedTabColor = useColorModeValue('green.700', 'green.200');
  const selectedTabBg = useColorModeValue('green.50', 'green.800');
  const tabHoverBg = useColorModeValue('gray.100', 'gray.700');

  return (
    <Box w="100%" py={8} px={{ base: 4, md: 8 }}>
      <Heading as="h2" size="lg" mb={6} color={useColorModeValue('gray.800', 'gray.100')}>
        Settings
      </Heading>
      <Tabs index={TABS.findIndex(t => t.key === tab)} onChange={(index) => setTab(TABS[index].key)} variant="soft-rounded" colorScheme="green">
        <TabList mb={4}>
          {TABS.map(t => (
            <Tab
              key={t.key}
              fontSize="md"
              fontWeight="semibold"
              py={2}
              px={4}
              color={tabColor}
              _selected={{
                color: selectedTabColor,
                bg: selectedTabBg,
              }}
              borderRadius="md"
              mr={2}
              _hover={{
                bg: tabHoverBg,
              }}
            >
              {t.label}
            </Tab>
          ))}
        </TabList>
        <TabPanels>
          {TABS.map(t => (
            <TabPanel key={t.key} p={0}>
              <Box
                bg={cardBg}
                borderRadius="lg"
                boxShadow="md"
                borderWidth={1}
                borderColor={borderColor}
                p={6}
                w="100%"
              >
                <ActiveTab {...props} />
              </Box>
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Box>
  );
} 